
const validateEmail = (curstring) => {
	/* Got the email regex from:
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input/email#validation
	 */
	// Added [a-z\d] at the start to require alphanumeric first character
	const emailRegex = /^[a-z\d][\w.!#$%&'*+/=?^`{|}~-]*@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*$/i;
	return validateString(curstring, emailRegex);
}

const validateMobile = (curstring, countryCode = "63") => {
	let mobileRegex;

	if (countryCode === "63" || countryCode === "0") {
		// If country code is 63, use PH number validation
		/* e.g. 09234567890 | +639234567890 */
		mobileRegex = /^(0|\+63)(8|9)([0-9]{9})$/g;
	} else if (!isNaN(parseInt(countryCode))) {
		// If country code is not 63, use generic validation but include the country code prefix
		mobileRegex = new RegExp(`^([+]${countryCode})?[().\\\s0-9,;-]*$`, "g")
		// begins with + countryCode, then 4-12 numbers
		// mobileRegex = new RegExp("^(\\+" + countrymobileprefix + ")\\d{4,12}$")
	} else {
		// If country code is set as blank, use the generic validation
		mobileRegex = /^[+]?[().\s0-9,;-]*$/g;
	}

	return validateString(curstring, mobileRegex);
}

const validateString = (curstring, regexstr) => {
	/* changed match() to test() since we just need a boolean value */
	return regexstr.test(curstring);
}

const filterNumeric = (num) => {
	var tmpnum = ""+num;
	return tmpnum.replace(/[^0-9.\-+]/g, '');
}

const filterInteger = (num) => {
	var tmpnum = ""+num;
	return tmpnum.replace(/[^0-9\-+]/g, '');
}

const integer = (num) => {
	return parseInt(numeric(num), 10)
}

const numeric = (num) => {
	var tmpnum = filterNumeric(num);
	if (tmpnum.length < 1)
		return 0;
	if (isNaN(parseFloat(tmpnum))) {
		return 0;
	}
	return parseFloat(tmpnum);
}


const currency = (num) => {
	//https://stackoverflow.com/questions/55556221/how-do-you-format-a-number-to-currency-when-using-react-native-expo
	return numeric(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const getDateStr = (tzoffsethr, utcdate = null) => {
	if (utcdate === null)
		utcdate = new Date();
	var tzoffsetfactor = 3600000;
	var tzoffsetms = 0;
	if(typeof tzoffsethr === "undefined") {
		tzoffsetms = 8*tzoffsetfactor; // GMT+8; Asia/Manila
	} else {
		tzoffsetms = tzoffsethr*tzoffsetfactor;
	}
	var localdate = new Date(utcdate.getTime()+tzoffsetms);
	var tmpstr = localdate.toISOString();
	return tmpstr.replace("T"," ").substring(0,19);
}

module.exports = {
	getDateStr,
	validateEmail,
	validateMobile,
	filterInteger,
	filterNumeric,
	currency,
	numeric,
	integer
}

